import {useState, useEffect} from 'react';
import InputForm from './InputForm';
import OutputForm from './OutputForm';
import {Fab, Grid} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import API from '../APIs/API';

export default function AdvisorIIVUL() {
    let [input, setInput] = useState(true);
    let [state, setState] = useState({
        gender: 'Male',
        age: '2',
        tobacco: 'Non Tobacco',
        amount: '200',
        data: {},
        dataReceived: false,
        ageError: false,
        amountError: false,
        overallError: false,
    });
    useEffect(() => {
        (async function () {
            if (input === false) {
                state.data =
                    (await API.Call('vul/', 'POST', {
                        key: `age=${state.age}|gender=${state.gender}|amount=${state.amount}|tobacco=${state.tobacco}`,
                    })) || {};
                state.dataReceived = true;
                setState({...state});
            }
        })();
    }, [input]);
    function changeFormState() {
        if (!state.overallError) {
            if (input) state.dataReceived = false;
            setInput(!input);
        }
    }
    function stateChanger(obj: any) {
        setState({...obj});
    }
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} onClick={changeFormState} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Fab color="primary">{input ? <ArrowForwardIcon /> : <CloseIcon />}</Fab>
            </Grid>
            <Grid item xs={12}>
                {input ? (
                    <InputForm state={state} stateChanger={stateChanger} />
                ) : state.dataReceived ? (
                    <OutputForm state={state} stateChanger={stateChanger} />
                ) : (
                    <div>loading... please wait...</div>
                )}
            </Grid>
        </Grid>
    );
}
